import { render, staticRenderFns } from "./FormWithConfirm.vue?vue&type=template&id=36b42fe7&scoped=true&"
import script from "./FormWithConfirm.vue?vue&type=script&lang=js&"
export * from "./FormWithConfirm.vue?vue&type=script&lang=js&"
import style0 from "./FormWithConfirm.vue?vue&type=style&index=0&id=36b42fe7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b42fe7",
  null
  
)

export default component.exports